import apiClient from './client'
import type { ApiResponse, User, LoginResult } from '@portal/types'

interface RefreshResult {
  accessToken: string
  refreshToken: string
  modules: string[]
  user: User
}

export const authApi = {
  login: (email: string, password: string) =>
    apiClient.post('/api/auth/login', { email, password }) as unknown as Promise<
      ApiResponse<LoginResult>
    >,

  verify2FA: (userId: string, code: string) =>
    apiClient.post('/api/auth/verify-2fa', { userId, code }) as unknown as Promise<
      ApiResponse<LoginResult>
    >,

  logout: (refreshToken: string) =>
    apiClient.post('/api/auth/logout', { refreshToken }) as unknown as Promise<ApiResponse<void>>,

  refresh: (refreshToken: string) =>
    apiClient.post('/api/auth/refresh', { refreshToken }) as unknown as Promise<
      ApiResponse<RefreshResult>
    >,

  getMe: () =>
    apiClient.get('/api/auth/me') as unknown as Promise<ApiResponse<User & { modules: string[] }>>,

  setup2FA: () =>
    apiClient.post('/api/auth/setup-2fa') as unknown as Promise<
      ApiResponse<{ secret: string; qrCodeUrl: string; manualEntryKey: string }>
    >,

  enable2FA: (code: string) =>
    apiClient.post('/api/auth/enable-2fa', { code }) as unknown as Promise<
      ApiResponse<{ success: boolean }>
    >,

  activate: (token: string, password: string) =>
    apiClient.post('/api/auth/activate', { token, password }) as unknown as Promise<
      ApiResponse<LoginResult>
    >,

  changePassword: (currentPassword: string, newPassword: string) =>
    apiClient.post('/api/auth/change-password', { currentPassword, newPassword }) as unknown as Promise<
      ApiResponse<{ success: boolean }>
    >,

  getMicrosoftUrl: () =>
    apiClient.get('/api/auth/microsoft/url') as unknown as Promise<
      ApiResponse<{ url: string; state: string }>
    >,

  microsoftCallback: (code: string, state: string, deviceId: string) =>
    apiClient.post('/api/auth/microsoft/callback', { code, state, deviceId }) as unknown as Promise<
      ApiResponse<LoginResult>
    >,
}
